<div class="css-Checkbox_Condiciones-1 checkbox_condiciones">
    <label class="css-Contenido contenido">
        <input type="checkbox" class="css-input_checkbox_checkAcepto input_checkbox_checkacepto"
            [(ngModel)]="terminosAceptados" (ngModelChange)="onInputChange($event)">
        <div class="css-Fill_text fill_text">
            <p class="css-Texto texto">Acepto los términos y condiciones</p>
        </div>
    </label>
    <div class="css-Enlace enlace">
        <div class="css-Enlace_icono_derecha-1 enlace_icono_derecha">
            <a class="css-a_Enlace_icono_derecha-1 a_enlace_icono_derecha">
                <p class="css-Texto_enlace-1 texto_enlace">Términos y condiciones de uso</p>
                <div class="css-Icono_Flecha_Dcha icono_flecha_dcha">
                    <img src="assets/images/basecomponents-images/vectors5321773.svg" width="12px" height="12px"
                        class="css-Vector_arrow_forward vector_arrowforward">
                </div>
            </a>
        </div>
    </div>
</div>